import React from 'react';

const PrivacyPolicy = () => (
  <div className="container py-4">
    <h2>Privacy Policy</h2>
    <h6 style={{ fontWeight: "bold" }}>Introduction</h6>
    <p style={{ fontSize: "small" }}>
      vakralabs.com website is a product of Vakralabs Services, located at Punawale, Pimpri-Chinchwad, Pune, Maharashtra - 411033.
      Please read these Privacy Policies carefully before using . The user must agree and accept all the terms before using the website.
    </p>
    <h6 style={{ fontWeight: "bold" }}>Information Collection</h6>
    <p style={{ fontSize: "small" }}>
      We collect basic personal details like name, email, mobile number, etc., for registration and service enhancement.
    </p>
    <h6 style={{ fontWeight: "bold" }}>Data Security</h6>
    <p style={{ fontSize: "small" }}>
      We implement reasonable security measures to safeguard your data. However, no system is fully secure and we cannot guarantee absolute protection.
    </p>
    <h6 style={{ fontWeight: "bold" }}>Cookies</h6>
    <p style={{ fontSize: "small" }}>
      We may use cookies to improve your experience and understand user behavior. Cookies do not collect personal information unless you provide it.
    </p>
    <h6 style={{ fontWeight: "bold" }}>Government Scheme Disclaimer</h6>
    <p style={{ fontSize: "small" }}>
      vakralabs.com website is not a government entity. All government scheme data is sourced from public websites and official news agencies. We do not represent any government body.
    </p>
    <h6 style={{ fontWeight: "bold" }}>Children's Privacy</h6>
    <p style={{ fontSize: "small" }}>
      We do not knowingly collect information from children under 13. If we find such data, it will be deleted immediately.
    </p>
    <h6 style={{ fontWeight: "bold" }}>Changes to This Policy</h6>
    <p style={{ fontSize: "small" }}>
      The policy may be updated periodically. We encourage users to check this page regularly for updates.
    </p>
    <h6 style={{ fontWeight: "bold" }}>Grievance Redressal</h6>
    <p style={{ fontSize: "small" }}>
      For issues related to privacy or misuse of content, please contact:
      <br />
      <strong>Grievance Officer</strong><br />
      Vakralabs Services<br />
      C-902, Bhalchandra Akashvan<br />
      Punawale, Pimpri-Chinchwad, Pune - 411033<br />
      📧 support@vakralabs.com
    </p>
  </div>
);

export default PrivacyPolicy;
